// extracted by mini-css-extract-plugin
export default {"socialButtons":"LoginForm_socialButtons__ncYeQ","submitError":"LoginForm_submitError__2AOT5"};